var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayFlg)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-bg",on:{"click":_vm.modalClose}}),_c('div',{staticClass:"term-modal-contents",attrs:{"id":"termsModal"},domProps:{"innerHTML":_vm._s(_vm.main)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }